export default __webpack_public_path__ + "static/mo-medsvc-a871502b0a52a73056c785b43179e22f.png";